fragment LandingPageHtmlFragment on Page {
    id
    name
    htmlUrlPath
    editableVersion {
        id
        htmlMaterialized
    }
}
